(() => {
  'use strict';

  const normalize = (value) => String(value || '')
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim().replace(/\s+/g, ' ');

  const FRONT_RE = /(^|\s)(front|face|avant|devant)(\s|$)/;
  const isFrontMedia = (item) => {
    const img = item?.querySelector?.('img');
    return FRONT_RE.test(normalize(`${img?.alt || ''} ${img?.currentSrc || img?.src || ''}`));
  };

  const colorAliases = {
    noir: ['noir','black'], black: ['black','noir'], blanc: ['blanc','white'], white: ['white','blanc'],
    rouge: ['rouge','red'], red: ['red','rouge'], bleu: ['bleu','blue'], blue: ['blue','bleu'],
    marine: ['marine','navy'], navy: ['navy','marine'], vert: ['vert','green'], green: ['green','vert'],
    gris: ['gris','grey','gray'], grey: ['grey','gray','gris'], gray: ['gray','grey','gris'],
    beige: ['beige','sand','sable'], sable: ['sable','sand','beige'], sand: ['sand','sable','beige'],
    violet: ['violet','purple'], purple: ['purple','violet'], rose: ['rose','pink'], pink: ['pink','rose'],
    marron: ['marron','brown'], brown: ['brown','marron'], bordeaux: ['bordeaux','burgundy'], burgundy: ['burgundy','bordeaux'],
    ecru: ['ecru','cream','creme'], creme: ['creme','cream','ecru'], cream: ['cream','creme','ecru'],
    orange: ['orange'], jaune: ['jaune','yellow'], yellow: ['yellow','jaune']
  };

  const termsForColor = (value) => {
    const key = normalize(value);
    return [...new Set([key, ...(colorAliases[key] || [])].map(normalize).filter(Boolean))];
  };

  const panelForToggle = (toggle) => {
    const controls = toggle.getAttribute('aria-controls');
    if (controls) {
      const byId = document.getElementById(controls);
      if (byId) return byId;
    }
    return toggle.closest('form,section,main')?.querySelector('[data-filter-panel]') || null;
  };

  const closeFilterPanel = (toggle, panel) => {
    if (!toggle || !panel) return;
    toggle.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-filter-toggle]');
    if (toggle) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const panel = panelForToggle(toggle);
      if (!panel) return;
      const open = toggle.getAttribute('aria-expanded') === 'true' && !panel.hidden;
      toggle.setAttribute('aria-expanded', String(!open));
      panel.hidden = open;
      if (!open) panel.querySelector('input:not([disabled]),button,a,select')?.focus({ preventScroll: true });
      return;
    }
    document.querySelectorAll('[data-filter-toggle][aria-expanded="true"]').forEach((openToggle) => {
      const panel = panelForToggle(openToggle);
      if (panel && !panel.contains(event.target)) closeFilterPanel(openToggle, panel);
    });
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-filter-toggle][aria-expanded="true"]').forEach((toggle) => {
      const panel = panelForToggle(toggle);
      closeFilterPanel(toggle, panel);
      toggle.focus();
    });
  });

  const getPageNumber = (href) => {
    try { return Number(new URL(href, location.href).searchParams.get('page') || 0); }
    catch (_) { return 0; }
  };

  const maxKnownPage = (doc = document) => [...doc.querySelectorAll('.pagination a[href]')]
    .reduce((max, link) => Math.max(max, getPageNumber(link.href)), 1);

  const fetchCollectionPage = async (page) => {
    const url = new URL(location.href);
    url.searchParams.set('page', String(page));
    const response = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!response.ok) return null;
    return new DOMParser().parseFromString(await response.text(), 'text/html');
  };

  const initQuickFilters = () => {
    const form = document.querySelector('#CollectionFilters');
    const grid = form?.closest('.section--compact')?.querySelector('.product-grid');
    if (!form || !grid || form.querySelector('[data-pk9-quick-filters]')) return;

    const toolbar = form.querySelector('.collection-toolbar');
    if (!toolbar) return;
    const wrapper = document.createElement('div');
    wrapper.className = 'pk9-quick-filters';
    wrapper.dataset.pk9QuickFilters = '';
    wrapper.setAttribute('role', 'group');
    wrapper.setAttribute('aria-label', 'Filtres rapides');
    wrapper.innerHTML = [
      ['homme', 'Homme'], ['femme', 'Femme'], ['nouveaute', 'Nouveauté']
    ].map(([key,label]) => `<button type="button" class="pk9-quick-filter" data-pk9-quick-filter="${key}" aria-pressed="false">${label} <span class="pk9-quick-filter-count" data-pk9-count="${key}"></span></button>`).join('');
    toolbar.insertAdjacentElement('afterend', wrapper);

    let loadedExtra = false;
    let loading = null;

    const allCards = () => [...grid.querySelectorAll('[data-pk9-card]')];
    const initialHandles = new Set(allCards().map((card) => card.dataset.productHandle));
    const pagination = () => form.closest('.section--compact')?.querySelector('.pagination');

    const updateCounts = () => {
      const cards = allCards();
      const counts = {
        homme: cards.filter((c) => (c.dataset.pk9Gender || '').split(' ').includes('homme')).length,
        femme: cards.filter((c) => (c.dataset.pk9Gender || '').split(' ').includes('femme')).length,
        nouveaute: cards.filter((c) => c.dataset.pk9New === 'true').length
      };
      Object.entries(counts).forEach(([key,count]) => {
        const node = wrapper.querySelector(`[data-pk9-count="${key}"]`);
        if (node) node.textContent = count ? `(${count})` : '';
      });
    };

    const loadAll = async () => {
      if (loadedExtra) return;
      if (loading) return loading;
      loading = (async () => {
        wrapper.classList.add('pk9-filter-loading');
        let page = 2;
        let safety = 0;
        let lastMax = maxKnownPage(document);
        const seen = new Set(allCards().map((c) => c.dataset.productHandle));
        while (safety++ < 50 && page <= Math.max(lastMax, page)) {
          const doc = await fetchCollectionPage(page);
          if (!doc) break;
          const cards = [...doc.querySelectorAll('.product-grid [data-pk9-card]')];
          if (!cards.length) break;
          let added = 0;
          cards.forEach((card) => {
            const handle = card.dataset.productHandle;
            if (!handle || seen.has(handle)) return;
            seen.add(handle);
            card.dataset.pk9LoadedExtra = 'true';
            grid.appendChild(card);
            added += 1;
          });
          lastMax = Math.max(lastMax, maxKnownPage(doc));
          const hasForwardLink = [...doc.querySelectorAll('.pagination a[href]')].some((a) => getPageNumber(a.href) > page);
          if (!hasForwardLink && page >= lastMax) break;
          if (!added && page >= lastMax) break;
          page += 1;
        }
        loadedExtra = true;
        wrapper.classList.remove('pk9-filter-loading');
        updateCounts();
      })();
      try { await loading; } finally { loading = null; }
    };

    const apply = async () => {
      const active = [...wrapper.querySelectorAll('[data-pk9-quick-filter][aria-pressed="true"]')].map((b) => b.dataset.pk9QuickFilter);
      if (active.length) await loadAll();
      const activeGenders = active.filter((x) => x === 'homme' || x === 'femme');
      const needsNew = active.includes('nouveaute');
      allCards().forEach((card) => {
        const genders = (card.dataset.pk9Gender || '').split(' ').filter(Boolean);
        const genderOk = !activeGenders.length || activeGenders.some((g) => genders.includes(g));
        const newOk = !needsNew || card.dataset.pk9New === 'true';
        const isExtra = card.dataset.pk9LoadedExtra === 'true' && !initialHandles.has(card.dataset.productHandle);
        const show = active.length ? (genderOk && newOk) : !isExtra;
        card.classList.toggle('pk9-card-filtered', !show);
      });
      pagination()?.classList.toggle('pk9-pagination-filtered', active.length > 0);
    };

    wrapper.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-pk9-quick-filter]');
      if (!button) return;
      button.setAttribute('aria-pressed', button.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      await apply();
    });
    updateCounts();
  };

  const productMeta = () => window.PK9_PRODUCT_META || null;

  const isPartnerProduct = (meta) => {
    if (!meta || normalize(meta.type) === 'abonnement') return false;
    const handles = Array.isArray(meta.collections) ? meta.collections.map(normalize) : [];
    const tags = Array.isArray(meta.tags) ? meta.tags.map(normalize) : [];
    const fingerprint = normalize(`${meta.title || ''} ${tags.join(' ')} ${handles.join(' ')}`);
    return handles.some((h) => h === 'clubs partenaires' || h === 'boutiques des clubs partenaires' || h.includes('club partenaire') || h.includes('collaboration') || h.includes('collab'))
      || tags.some((t) => t.includes('club partenaire') || t.includes('collaboration') || t.includes('pk9 club only'))
      || /(^|\s)(fpl|apc|gap x pk9|pk9 x| x pk9)(\s|$)/.test(fingerprint);
  };

  const ensurePseudo = () => {
    const meta = productMeta();
    const form = document.querySelector('[data-product-form]');
    const panel = form?.querySelector('.product__purchase-panel');
    if (!form || !panel || !isPartnerProduct(meta) || panel.querySelector('.pk9-pseudo-option')) return;
    const block = document.createElement('div');
    block.className = 'pk9-pseudo-option pk9-pseudo-option--injected';
    block.innerHTML = '<label for="Pk9InjectedPseudo"><span>MON PSEUDO</span><small>Personnalisation optionnelle</small></label><input id="Pk9InjectedPseudo" type="text" name="properties[Mon pseudo]" maxlength="20" placeholder="Ex. RiverKing83" autocomplete="off"><p>20 caractères maximum. Laissez vide si vous ne souhaitez pas ajouter de pseudo.</p>';
    const purchase = panel.querySelector('[data-primary-purchase]');
    panel.insertBefore(block, purchase || null);
  };

  const hasNativeSize = (meta) => (meta?.options || []).some((name) => /(^|\s)(taille|size)(\s|$)/.test(normalize(name)));
  const needsSize = (meta) => {
    if (!meta || hasNativeSize(meta) || normalize(meta.type) === 'abonnement') return false;
    const text = normalize(`${meta.title || ''} ${meta.type || ''} ${(meta.tags || []).join(' ')}`);
    if (/(casquette|trucker|bonnet|mug|tasse|carte|table|sac|backpack|photo|masterclass|abonnement|bracelet|bijou|accessoire)/.test(text)) return false;
    return /(hoodie|sweat|t shirt|tshirt|tee shirt|polo|zipper|veste|bomber|pantalon|jogger|short|debardeur|tank|tennis|chaussure|sneaker|outfit|pull|chemise)/.test(text);
  };

  const ensureFallbackSize = () => {
    const meta = productMeta();
    const form = document.querySelector('[data-product-form]');
    const panel = form?.querySelector('.product__purchase-panel');
    if (!form || !panel || !needsSize(meta) || form.querySelector('[name="properties[Taille]"]')) return;
    const text = normalize(`${meta.title || ''} ${meta.type || ''}`);
    const footwear = /(tennis|chaussure|sneaker)/.test(text);
    const sizes = footwear ? ['36','37','38','39','40','41','42','43','44','45','46'] : ['XS','S','M','L','XL','2XL','3XL','4XL'];
    let host = panel.querySelector('.product__secondary-options');
    if (!host) {
      host = document.createElement('div');
      host.className = 'product__secondary-options';
      panel.insertBefore(host, panel.querySelector('.pk9-pseudo-option,[data-primary-purchase]'));
    }
    const block = document.createElement('div');
    block.className = 'pk9-fallback-size product__option';
    block.innerHTML = `<label for="Pk9FallbackSize">Taille</label><select id="Pk9FallbackSize" name="properties[Taille]" required><option value="">Choisir une taille</option>${sizes.map((size) => `<option value="${size}">${size}</option>`).join('')}</select>`;
    host.appendChild(block);
  };

  const selectedColorInfo = (picker) => {
    const group = picker?.querySelector('[data-color-option]');
    const checked = group?.querySelector('[data-option-value]:checked');
    if (!group || !checked) return null;
    return { value: normalize(checked.value), terms: termsForColor(checked.value), index: Number(group.dataset.optionIndex || 0) };
  };

  const mediaText = (item) => {
    const img = item.querySelector('img');
    return normalize(`${img?.alt || ''} ${img?.currentSrc || ''} ${img?.src || ''}`);
  };

  const syncColorGallery = () => {
    const picker = document.querySelector('[data-variant-picker]');
    const gallery = document.querySelector('[data-product-gallery]');
    const color = selectedColorInfo(picker);
    if (!picker || !gallery || !color) return;
    let variants = [];
    try { variants = JSON.parse(picker.querySelector('[data-variant-data]')?.textContent || '[]'); } catch (_) {}
    const colorIndex = color.index;
    const ownership = new Map();
    const keyOf = (value) => String(value || '').match(/(\d+)(?:\D*)$/)?.[1] || String(value || '');
    const pathOf = (src) => { try { return new URL(src, location.origin).pathname; } catch (_) { return String(src || '').split('?')[0]; } };
    variants.forEach((variant) => {
      const owner = normalize(variant.options?.[colorIndex]);
      const id = keyOf(variant.featured_media?.id || variant.featured_image?.id || '');
      const src = variant.featured_image?.src || variant.featured_image?.url || variant.featured_media?.preview_image?.src || '';
      if (id) { if (!ownership.has(`id:${id}`)) ownership.set(`id:${id}`, new Set()); ownership.get(`id:${id}`).add(owner); }
      if (src) { const path = pathOf(src); if (!ownership.has(`path:${path}`)) ownership.set(`path:${path}`, new Set()); ownership.get(`path:${path}`).add(owner); }
    });

    const knownColors = [...new Set([...picker.querySelectorAll('[data-color-option] [data-option-value]')].flatMap((input) => termsForColor(input.value)))];
    const items = [...gallery.querySelectorAll('.product__media')];
    items.forEach((item) => {
      const img = item.querySelector('img');
      const id = keyOf(item.dataset.mediaId || '');
      const paths = [img?.currentSrc, img?.src].filter(Boolean).map(pathOf);
      const owners = ownership.get(`id:${id}`) || paths.map((p) => ownership.get(`path:${p}`)).find(Boolean);
      const text = mediaText(item);
      const explicitColors = knownColors.filter((term) => term && (` ${text} `).includes(` ${term} `));
      const aliasMatch = color.terms.some((term) => term && (` ${text} `).includes(` ${term} `));
      let visible = true;
      if (owners?.size) visible = owners.has(color.value);
      else if (explicitColors.length) visible = aliasMatch;
      item.style.display = visible ? '' : 'none';
    });

    const visible = items.filter((item) => item.style.display !== 'none');
    const front = visible.find(isFrontMedia);
    if (front) gallery.insertBefore(front, gallery.firstElementChild);
    const firstVisible = [...gallery.querySelectorAll('.product__media')].find((item) => item.style.display !== 'none');
    if (firstVisible) gallery.scrollTo({ left: firstVisible.offsetLeft, behavior: 'auto' });
  };

  const ensureFrontFirst = () => {
    const gallery = document.querySelector('[data-product-gallery]');
    if (!gallery) return;
    const visible = [...gallery.querySelectorAll('.product__media')].filter((item) => item.style.display !== 'none');
    const front = visible.find(isFrontMedia);
    if (front) gallery.insertBefore(front, gallery.firstElementChild);
  };

  const initProduct = () => {
    if (!document.querySelector('[data-product-form]')) return;
    ensureFallbackSize();
    ensurePseudo();
    ensureFrontFirst();
    setTimeout(syncColorGallery, 80);
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-option-value]')) setTimeout(syncColorGallery, 80);
  });

  const init = () => { initQuickFilters(); initProduct(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', () => setTimeout(init, 0));
})();